<template>
  <div id="vacant" class="div_card">
    <div v-if="docRecord==null">      
      <el-alert
        title="資料讀取中…"
        type="info"
        show-icon
        center
        :closable="false">
      </el-alert>
    </div>
    <div v-else-if="docRecord!=null && docRecord.status==1">
      <div class="">
        <div class="">
          <table class="w-100" style="background-color: azure; border: gray;" rules="all" bgcolor="#FFFFFF" >
            <thead>
              <tr>
                <th colspan="4" class="ncut-base-form-title" style="background-color: orange; text-align:left; padding: 0.5em;">備取生保留登結果如下:</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="ncut-base-form-title" style="padding:0.5em;">報名系科</td>
                <td colspan="3" style="padding:0.1em;">
                  <span class="badge badge-primary" style="font-size:1.5rem">{{docRecord.text1}}</span>
                </td>
              </tr>
              <tr>
                <td class="ncut-base-form-title" style="width: 14%;padding:0.5em;">考生姓名</td>
                <td style="padding:0.1em;">
                  <span class="badge badge-info" style="font-size:1.25rem">{{docRecord.name}}</span>
                </td>
                <td class="ncut-base-form-title" style="width: 14%;padding:0.5em;">報名編號</td>
                <td style="padding:0.1em;">
                  <span class="badge badge-info" style="font-size:1.25rem">{{docRecord.regNo}}</span>
                </td>
              </tr>
              <tr>
                <td class="ncut-base-form-title" style="padding:0.5em;">錄取狀況</td>
                <td colspan="3" style="padding:0.1em;">
                  <span class="ncut-badge" style="font-size: 1.25rem">{{docRecord.text2}}</span>
                </td>
              </tr>
              <tr>
                <td class="ncut-base-form-title" style="padding:0.5em;">保留登錄情況</td>
                <td colspan="3" style="padding:0.1em;">
                  <span class="ncut-badge" style="font-size: 1.25rem">{{docRecord.text3}}</span>
                </td>
              </tr>
              <tr>
                <td class="ncut-base-form-title">備註</td>
                <td colspan="3" style="padding: 0.5em;">
                  <div style="white-space: pre-line; ">{{docRecord.text4}}</div>
                </td>
              </tr>
            </tbody>
          </table>
          <el-row style="padding: 1em 0 0;"
            v-if="4 == docRecord.statusID">
            <el-button type="primary" @click="submit(1)">備取生保留登錄<i class="el-icon-view"></i></el-button>
            <el-button type="warning" @click="submit(2)">放棄保留<i class="el-icon-view"></i></el-button>
          </el-row>
        </div>
      </div>
    </div>
    <div v-else-if="docRecord!=null && docRecord.status==5">
      <el-alert
        title="請先完成網路報名。"
        type="error"
        show-icon
        center
        :closable="false">
      </el-alert>
    </div>
    <div v-else>
      <el-alert
        title="尚無資料，請耐心等候，謝謝!!"
        type="warning"
        show-icon
        center
        :closable="false">
      </el-alert>
    </div> 
  </div> 
</template>


<script>
export default {
  name: 'vVacant',
  data () {
    return {
      docRecord: null
    }
  },
  computed: {
    sysId () {
      return this.$store.getters.getSysId
    },
    setting () {
      return this.$store.getters.getSetting
    },
    enroll () {
      return this.$store.getters.getEnrollInfo
    },
    user () {
      return this.$store.getters.getUser
    }
  },
  methods: {
    isSuccess(str) {
      return ((str == "true") || (str == "True") || (str == true) ? true : false);
    },
    showErrorMsg( vm, error) {
      vm.$notify.error({
                          title: vm.$t('message.Error_txt'),
                          dangerouslyUseHTMLString: true,
                          message: '<strong>對不起,網路連線失敗' + error+'</strong>',
                          offset: 150
                        });
    },
    submit(type) {
      var vm = this; 
      vm.$http.put('./WebApi/Apply/SetVacantInfo/'.concat(this.user.id).concat('/').concat(this.user.hId).concat('/').concat(type))
              .then((success) =>{          
                if (vm.isSuccess(success.data)) {
                  vm.$message({
                                message: '恭喜您,存檔成功',
                                type: 'success'
                              });
                  vm.query();
                }
              })
              .catch(function (error) {
                vm.showErrorMsg(vm, '<strong>對不起,網路連線失敗' + error+'</strong>');
              }); 
    },
    query() {
      var vm = this
      this.$http
          .get('./WebApi/Apply/GetVacantInfo/'.concat(this.user.hId))
          .then(function(response) {
            if (response.data != null) {
              vm.docRecord = response.data
            } else {
              vm.showErrorMsg(vm, '<strong>對不起,讀取<i style="background:yellow;">分發結果</i>查詢失敗:'+error+'</strong>');
            }
          })
          .catch(function (error) {
            vm.showErrorMsg(vm, '<strong>對不起,網路連線失敗' + error+'</strong>');
          })
    } 
  },
  created () { 
    console.log('======created VacantView=====');
    this.query();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/VacantView.vue